"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeVisualizationUtils = void 0;
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const gl_matrix_1 = require("gl-matrix");
const IAttribute_1 = require("../interfaces/IAttribute");
const grayscaleVisualization = (factor, materialType) => {
    const color = Math.floor(factor * 255.0);
    return {
        material: materialType === 'unlit' ? new viewer_shared_types_1.MaterialUnlitData({ color: 'rgb(' + color + ', ' + color + ', ' + color + ')', opacity: 1 }) : new viewer_shared_types_1.MaterialStandardData({ color: 'rgb(' + color + ', ' + color + ', ' + color + ')', opacity: 1 }),
        matrix: gl_matrix_1.mat4.create()
    };
};
const opacityVisualization = (factor, materialType, defaultMaterial) => {
    return {
        material: materialType === 'unlit' ? new viewer_shared_types_1.MaterialUnlitData({ color: defaultMaterial.color, opacity: factor }) : new viewer_shared_types_1.MaterialStandardData({ color: defaultMaterial.color, opacity: factor }),
        matrix: gl_matrix_1.mat4.create()
    };
};
const blueRedVisualization = (factor, materialType) => {
    const red = factor * 255.0;
    const blue = (1 - factor) * 255.0;
    return {
        material: materialType === 'unlit' ? new viewer_shared_types_1.MaterialUnlitData({ color: 'rgb(' + Math.floor(red) + ', ' + Math.floor(0) + ', ' + Math.floor(blue) + ')', opacity: 1 }) : new viewer_shared_types_1.MaterialStandardData({ color: 'rgb(' + Math.floor(red) + ', ' + Math.floor(0) + ', ' + Math.floor(blue) + ')', opacity: 1 }),
        matrix: gl_matrix_1.mat4.create()
    };
};
const blueWhiteRedVisualization = (factor, materialType) => {
    let red = 255, green = 255, blue = 255;
    if (factor < 0.5) {
        const remappedFactor = factor / 0.5;
        red = 255.0 * remappedFactor;
        green = 255.0 * remappedFactor;
        blue = 255.0;
    }
    else {
        const remappedFactor = (factor - 0.5) / 0.5;
        red = 255.0;
        green = 255.0 * (1 - remappedFactor);
        blue = 255.0 * (1 - remappedFactor);
    }
    return {
        material: materialType === 'unlit' ? new viewer_shared_types_1.MaterialUnlitData({ color: 'rgb(' + Math.floor(red) + ', ' + Math.floor(green) + ', ' + Math.floor(blue) + ')', opacity: 1 }) : new viewer_shared_types_1.MaterialStandardData({ color: 'rgb(' + Math.floor(red) + ', ' + Math.floor(green) + ', ' + Math.floor(blue) + ')', opacity: 1 }),
        matrix: gl_matrix_1.mat4.create()
    };
};
const greenRedVisualization = (factor, materialType) => {
    const red = factor * 255.0;
    const green = (1 - factor) * 255.0;
    return {
        material: materialType === 'unlit' ? new viewer_shared_types_1.MaterialUnlitData({ color: 'rgb(' + Math.floor(red) + ', ' + Math.floor(green) + ', ' + Math.floor(0) + ')', opacity: 1 }) : new viewer_shared_types_1.MaterialStandardData({ color: 'rgb(' + Math.floor(red) + ', ' + Math.floor(green) + ', ' + Math.floor(0) + ')', opacity: 1 }),
        matrix: gl_matrix_1.mat4.create()
    };
};
const greenWhiteRedVisualization = (factor, materialType) => {
    let red = 255, green = 255, blue = 255;
    if (factor < 0.5) {
        const remappedFactor = factor / 0.5;
        red = 255.0 * remappedFactor;
        green = 255.0;
        blue = 255.0 * remappedFactor;
    }
    else {
        const remappedFactor = (factor - 0.5) / 0.5;
        red = 255.0;
        green = 255.0 * (1 - remappedFactor);
        blue = 255.0 * (1 - remappedFactor);
    }
    return {
        material: materialType === 'unlit' ? new viewer_shared_types_1.MaterialUnlitData({ color: 'rgb(' + Math.floor(red) + ', ' + Math.floor(green) + ', ' + Math.floor(blue) + ')', opacity: 1 }) : new viewer_shared_types_1.MaterialStandardData({ color: 'rgb(' + Math.floor(red) + ', ' + Math.floor(green) + ', ' + Math.floor(blue) + ')', opacity: 1 }),
        matrix: gl_matrix_1.mat4.create()
    };
};
const blueGreenRedVisualization = (factor, materialType) => {
    let red = 255, green = 255, blue = 255;
    if (factor < 0.5) {
        const remappedFactor = factor / 0.5;
        red = 0;
        green = 255.0 * remappedFactor;
        blue = 255.0 * (1 - remappedFactor);
    }
    else {
        const remappedFactor = (factor - 0.5) / 0.5;
        red = 255.0 * remappedFactor;
        green = 255.0 * (1 - remappedFactor);
        blue = 0;
    }
    return {
        material: materialType === 'unlit' ? new viewer_shared_types_1.MaterialUnlitData({ color: 'rgb(' + Math.floor(red) + ', ' + Math.floor(green) + ', ' + Math.floor(blue) + ')', opacity: 1 }) : new viewer_shared_types_1.MaterialStandardData({ color: 'rgb(' + Math.floor(red) + ', ' + Math.floor(green) + ', ' + Math.floor(blue) + ')', opacity: 1 }),
        matrix: gl_matrix_1.mat4.create()
    };
};
const blueGreenYellowRedPurpleWhiteVisualization = (factor, materialType) => {
    let red = 255, green = 255, blue = 255;
    if (factor < 0.2) {
        const remappedFactor = factor / 0.2;
        red = 0;
        green = 255.0 * remappedFactor;
        blue = 255.0 * (1 - remappedFactor);
    }
    else if (factor < 0.4) {
        const remappedFactor = (factor - 0.2) / 0.2;
        red = 255.0 * remappedFactor;
        green = 255.0;
        blue = 0.0;
    }
    else if (factor < 0.6) {
        const remappedFactor = (factor - 0.4) / 0.2;
        red = 255.0;
        green = 255.0 * (1 - remappedFactor);
        blue = 0.0;
    }
    else if (factor < 0.8) {
        const remappedFactor = (factor - 0.6) / 0.2;
        red = 255.0;
        green = 0.0;
        blue = 255.0 * remappedFactor;
    }
    else {
        const remappedFactor = (factor - 0.8) / 0.2;
        red = 255.0;
        green = 255.0 * remappedFactor;
        blue = 255.0;
    }
    return {
        material: materialType === 'unlit' ? new viewer_shared_types_1.MaterialUnlitData({ color: 'rgb(' + Math.floor(red) + ', ' + Math.floor(green) + ', ' + Math.floor(blue) + ')', opacity: 1 }) : new viewer_shared_types_1.MaterialStandardData({ color: 'rgb(' + Math.floor(red) + ', ' + Math.floor(green) + ', ' + Math.floor(blue) + ')', opacity: 1 }),
        matrix: gl_matrix_1.mat4.create()
    };
};
const hslVisualization = (factor, materialType) => {
    const hue = factor * 359.99;
    return {
        material: materialType === 'unlit' ? new viewer_shared_types_1.MaterialUnlitData({ color: 'hsl(' + Math.floor(hue) + ', 100%, 50%)', opacity: 1 }) : new viewer_shared_types_1.MaterialStandardData({ color: 'hsl(' + Math.floor(hue) + ', 100%, 50%)', opacity: 1 }),
        matrix: gl_matrix_1.mat4.create()
    };
};
const numberVisualization = (value, min, max, type, materialType, defaultMaterial) => {
    let factor = (value - min) / (max - min);
    factor = Math.min(1, Math.max(0, factor));
    switch (type) {
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.GRAYSCALE:
            return grayscaleVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.OPACITY:
            return opacityVisualization(factor, materialType, defaultMaterial);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.BLUE_RED:
            return blueRedVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.BLUE_WHITE_RED:
            return blueWhiteRedVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.GREEN_RED:
            return greenRedVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.GREEN_WHITE_RED:
            return greenWhiteRedVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.BLUE_GREEN_RED:
            return blueGreenRedVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.BLUE_GREEN_YELLOW_RED_PURPLE_WHITE:
            return blueGreenYellowRedPurpleWhiteVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.HSL:
            return hslVisualization(factor, materialType);
    }
};
const stringVisualization = (value, values, type, materialType, defaultMaterial) => {
    let factor = values.indexOf(value) / (values.length - 1);
    factor = Math.min(1, Math.max(0, factor));
    switch (type) {
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.GRAYSCALE:
            return grayscaleVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.OPACITY:
            return opacityVisualization(factor, materialType, defaultMaterial);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.BLUE_RED:
            return blueRedVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.BLUE_WHITE_RED:
            return blueWhiteRedVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.GREEN_RED:
            return greenRedVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.GREEN_WHITE_RED:
            return greenWhiteRedVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.BLUE_GREEN_RED:
            return blueGreenRedVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.BLUE_GREEN_YELLOW_RED_PURPLE_WHITE:
            return blueGreenYellowRedPurpleWhiteVisualization(factor, materialType);
        case IAttribute_1.ATTRIBUTE_VISUALIZATION.HSL:
            return hslVisualization(factor, materialType);
    }
};
exports.AttributeVisualizationUtils = {
    numberVisualization,
    stringVisualization
};
//# sourceMappingURL=AttributeVisualizationUtils.js.map